export default {
    details: 'The page you are looking for does not exist.',
    goHome: 'Go to home',
    title: 'Page not found.',
};
